import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Card,
  CardMedia,
  CardContent,
  useTheme,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../common/form/CustomTypography";
import { StockCheckSuggestedProducts } from "../../../models/Stock/Stock";

interface SuggestedProductsModalProps {
  open: boolean;
  onClose: () => void;
  products: StockCheckSuggestedProducts[];
}

const SuggestedProductsModal: React.FC<SuggestedProductsModalProps> = ({
  open,
  onClose,
  products,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <CustomTypography variant="heading4">
          Suggested Products
        </CustomTypography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexWrap="wrap" gap={2} justifyContent="flex-start">
          {products.map((product) => (
            <Card
              key={product.product_id}
              sx={{
                width: 250,
                boxShadow: 3,
                borderRadius: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {product.product_image_urls &&
              product.product_image_urls.length > 0 ? (
                <CardMedia
                  component="img"
                  image={product.product_image_urls[0]}
                  alt={product.product_name}
                  sx={{ height: 220, p: 1, pb: 0 }}
                />
              ) : (
                <Box
                  sx={{
                    height: 150,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[200],
                  }}
                >
                  <CustomTypography variant="body2">
                    No Image Available
                  </CustomTypography>
                </Box>
              )}
              <CardContent>
                <CustomTypography variant="body2">
                  {product.product_name}
                </CustomTypography>

                {/* <CustomTypography variant="body2">
                  Vendor: {product.vendor_name || ""}
                </CustomTypography> */}

                {product.timeline && (
                  <CustomTypography variant="body2">
                    Timeline: {product.timeline || ""}
                  </CustomTypography>
                )}
              </CardContent>
            </Card>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuggestedProductsModal;
